export default function () {
  return [
    {
      title: '姓名',
      [$field]: 'memberUserName',
      width: 100
    },
    {
      title: '组织',
      [$field]: 'memberOrgName',
      width: 150
    },
    {
      title: '评审身份',
      [$field]: 'identity',
      width: 100,
      render: (h, {row}) => {
        return h('span', this.dictMap['BOE39'][row.memberIdentity])
      }
    },
    {
      title: '身份赋权',
      [$field]: 'operateAuthority',
      render: (h, {row}) => {
        const map = this.dictMap['BOE40']
        const Checkboxs = Object.keys(map).map(item => {
          if (item !== 'CZQX01' && row.memberIdentity === 'PSSF03') {
            return null
          } else {
            return h('Checkbox', {
              props: {
                value: row.operateAuthority.includes(item),
                disabled: row.disabled || this.$route.name !== 'reviewScoring'
              },
              on: {
                'on-change': (val) => {
                  if (row.operateAuthority.includes(item) && !val) {
                    const ind = row.operateAuthority.findIndex(v => v === item)
                    row.operateAuthority.splice(ind, 1)
                  } else if (val && !row.operateAuthority.includes(item)) {
                    row.operateAuthority.push(item)
                  }
                  row.operateAuthority.sort(function (a, b) {
                    let suffix = a.substring(a.length - 1)
                    let nextSunffix = b.substring(b.length - 1)
                    return suffix - nextSunffix
                  })
                }
              },
              class: 'iv-m-l-16 iv-fs-16 iv-fc-65'
            }, map[item])
          }
        }).filter(v => v)
        return ('div', [...Checkboxs])
        // return h('CheckboxGroup', {
        //   props: {
        //     value: row.operateAuthority
        //   }
        // }, [...Checkboxs])
      }
    }
    // {
    //   'title': '操作',
    //   'width': 160,
    //   [$field]: 'operate',
    //   'isOperate': true
    // }
  ]
}